module.exports = __webpack_public_path__ + "img/mfb-logo.4b874373.png";